<!--填空题-->
<template>
  <div class="uni-question-wrap">
    <QrCode ref="qrCode" @getUpdateImg="getUpdateImg" @closeQr="closeQr" />
    <div class="subject">
      <div class="stem" v-if="!isHideName">
        <div class="nameText">
          <!-- 编号 -->
          <em
            v-if="$route.path === '/practiceAnalysis'"
            :class="`${toggleClass(datas.is_make)}`"
            >{{ datas.sort }}</em
          >
          <em v-else>{{ datas.sort }}</em>

          <!-- 题目 -->
          <p style="flex: 1">
            <!-- <span>[{{ qStyle[datas.question_style] }}]</span> -->
            <span>[{{ datas.question_title }}]</span>
            <i style="flex: 1" class="mal10">
              <!-- v-html="datas.title" -->
              <span style="color: #343434 !important; white-space: pre-wrap;">{{ datas.title }}</span>
              (本题{{ datas.fraction }}分)
            </i>
            <i v-if="datas.title_thumb">(点击图片放大)</i>
          </p>
        </div>

        <!-- 查看解析 -->
        <div class="operation" @click="showAnalysis" v-if="isAnalysis">
          <div class="uni-cursor" :class="{ active: isAnalysis }">
            <i class="iconfont iconhuabanfuben"></i>
            <span>查看解析</span>
          </div>
        </div>
      </div>

      <!-- 音频 -->
      <div class="audioDiv" v-if="datas.audio_url">
        <audio
          class="sourceAudio"
          controls="controls"
          v-for="(itemAudio, indexAudio) in datas.audio_url.split(',')"
          :key="indexAudio"
        >
          <source :src="itemAudio" type="audio/ogg" />
          Your browser does not support the audio element.
        </audio>
      </div>

      <!-- 题目图片 -->
      <el-image
        v-if="datas.title_thumb"
        class="mat20 mal20"
        style="width: 200px; color: #fff"
        fit="contain"
        :src="datas.title_thumb"
        :preview-src-list="[datas.title_thumb]"
      />

      <ul v-if="datas.is_file_up == 0" class="answer-box">
        <li class="item">
          <p class="tit mal20 mar20">文字输入:</p>
          <el-input
            v-model="datas.choice_correct_item"
            style="width: 50%"
            type="textarea"
            @blur="theRadio"
            :rows="6"
            :disabled="isDisabled"
            @paste.native.capture.prevent="handleFalse"
            @copy.native.capture.prevent="handleFalse"
            @cut.native.capture.prevent="handleFalse"
          />
        </li>
      </ul>

      <div v-if="datas.is_file_up == 0" class="blanksDiv">
        <div v-if="datas.is_img_up == 1">
          <p>上传图片</p>
          <div class="update">
            <!-- <div
              class="updateImgDiv"
              :class="{updateImgDivActive:isDisabled}"
              v-if="datas.choice_correct_thumb"
            >
              <i
                class="el-icon-close detIcon"
                @click="setDelete()"
              ></i>
              <el-image
                class="updateImg"
                fit="cover"
                :src="datas.choice_correct_thumb"
              />
            </div> -->
            <div style="display: flex;flex-wrap: wrap;">
              <div
                class="updateImgDiv"
                :class="{updateImgDivActive:isDisabled}"
                v-for="(item, index) in datas.choice_correct_thumb" :key="index"
                style="margin-bottom: 5px;"
              >
                <i
                  class="el-icon-close detIcon"
                  @click="setDelete(index)"
                ></i>
                <el-image
                  class="updateImg"
                  fit="cover"
                  :src="item"
                />
              </div>
              <div class="updateImgDiv" :class="{updateImgDivActive:isDisabled}" @click="openQrCode">
                <i class="el-icon-plus"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="datas.is_file_up == 1" class="blanksDiv" style="margin-top: 20px;">
        <!-- <p>上传图片</p> -->
        <div class="update">
          <FalConUpload
            ref="FileRef"
            listStyle='text'
            accept=".zip,.rar,.7z,.pdf,.doc,.docx"
            :isFile="true"
            :fileLists="datas.choice_correct_thumb"
            @handleRemove="handleRemoveFile"
            @handleChange="handleChangeFile"
          >
          </FalConUpload>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { questionMixin } from "./common.js";
import { getStore } from "@/utils/localStorage";
import { faceServe } from "@/api/home";
import QrCode from "../onlineTest/module/qrCode";
import FalConUpload from "@/components/uploadFile";
import {putObject, uploadFiles} from "@/utils/upload";
export default {
  name: "Subjective",
  mixins: [questionMixin],
  components: { QrCode, FalConUpload },
  props: {
    isAnalysis: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isTime:""
    };
  },
  created() {
    this.imgHandle();
  },
  methods: {
     // 上传文件
    handleChangeFile(data) {
      uploadFiles(data.fileList, (urls) => {
        this.datas.choice_correct_thumb = urls;
        this.$emit("next", true);
      }, null, 'student', '', true);
    },
    //  删除 文件
    handleRemoveFile(data) {
      this.datas.choice_correct_thumb = data.fileList;
    },
    // 处理图片/文件
    imgHandle(){
      if(this.datas.is_file_up == 1){
        if(this.datas.choice_correct_thumb === '' || this.datas.choice_correct_thumb === 'null' || this.datas.choice_correct_thumb === null){
          this.datas.choice_correct_thumb = [];
        }else{
          this.datas.choice_correct_thumb = JSON.parse(this.datas.choice_correct_thumb);
        }
      }else{
        if(this.datas.choice_correct_thumb === '' || this.datas.choice_correct_thumb === 'null' || this.datas.choice_correct_thumb === null){
          this.datas.choice_correct_thumb = [];
        }else{
          this.datas.choice_correct_thumb = this.datas.choice_correct_thumb.split(',');
        }
      }
    },
    openQrCode(indexNumTop){
      if(this.isDisabled)return
      this.indexNumTop = indexNumTop;
      this.$refs.qrCode.isShowOpen();
    },
    // 删除图片
    setDelete(index) {
      // this.datas.choice_correct_thumb = "";
      this.datas.choice_correct_thumb.splice(index, 1);
      // if(this.datas.choice_correct_thumb.length == 0){
      //   this.datas.choice_correct_thumb = '';
      // }

      this.$emit("next", true);
      
    },

    // 获取上次图片
    getUpdateImg() {
      const mobileData = JSON.parse(getStore("userInfo")).mobile;
      const studentId = JSON.parse(getStore("userInfo")).student_id;
      const _ENTRANCETYPE = this.$store.state.permission._ENTRANCETYPE;
      let time = this.$store.state.common.time;
      let tag = _ENTRANCETYPE + studentId + mobileData + time;
      this.isTime = setInterval(() => {
        faceServe
          .getStudent({
            tag: tag,
          })
          .then(({ result }) => {
            if (result.url) {
              if(this.datas.choice_correct_thumb === '' || this.datas.choice_correct_thumb === 'null' || this.datas.choice_correct_thumb === null){
                this.datas.choice_correct_thumb = [];
              }
              this.datas.choice_correct_thumb = [...this.datas.choice_correct_thumb, ...result.url.split(',')];
              this.$refs.qrCode.isHideOpen();
              this.$emit("next", true);
            }
          });
      }, 3000);
    },
    closeQr() {
      if (this.isTime) {
        clearInterval(this.isTime);
        this.isTime = null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./common.scss";
.answer-box {
  .item {
    display: flex;
    margin-top: 20px;
  }
}

.blanksDiv{
  margin: 0 20px;
  p {
    margin-bottom: 10px;
  }
  .update {
    display: flex;

    .updateImgDiv {
      width: 100px;
      height: 100px;
      border: 1px solid #e8e8e8;
      margin-right: 20px;
      position: relative;
      z-index: 1;
      box-sizing: content-box;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .updateImg {
        width: 100px;
        height: 100px;
      }
      .detIcon {
        position: absolute;
        right: -10px;
        top: -10px;
        z-index: 5;
        cursor: pointer;
        background: #666;
        padding: 5px;
        border-radius: 50%;
        color: #fff;
      }
    }


  }
}
.updateImgDivActive{
  cursor: no-drop !important;
}
</style>
